var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PayPalCasesTableUser',{attrs:{"filterGetParams":_vm.filterGetParams,"countFilterParams":_vm.countFilterParams},on:{"filter":_vm.filter,"changeFilter":_vm.changeFilter,"resetFilter":_vm.resetFilter,"showMore":_vm.showMore,"downloadFiles":_vm.downloadFiles}})
}
var staticRenderFns = []

export { render, staticRenderFns }